// import React, { useMemo, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useSiteConfig } from "../../context/SiteConfigContext";
// import { useCart } from "../../context/CartContext";
// import { Heart } from "lucide-react";
// import { showError } from "../../utils/toastUtils";
// import Auth from "../../utils/AuthUtils";
// import wishlistAPI from "../../api/wishlistApi";

// function Card({ item }) {
//   const { addToCart } = useCart();
//   const navigate = useNavigate();
//   const { config } = useSiteConfig();

//   const initialPrice =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.price ?? 0)
//       : (item?.price ?? 0);

//   const initialMrp =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.mrp ?? 0)
//       : (item?.mrp ?? 0);

//   const initialDiscount =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.discount ?? 0)
//       : (item?.discount ?? 0);

//   const initialStock =
//     item?.productType === "Variant"
//       ? (item?.variants?.[0]?.stock ?? 0)
//       : (item?.stock ?? 0);

//   const [slug] = useState(item?.slug);
//   const [title] = useState(item?.title);
//   const [activePrice, setActivePrice] = useState(initialPrice);
//   const [activeMrp, setActiveMrp] = useState(initialMrp);
//   const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
//   const [activeStock, setActiveStock] = useState(initialStock);
//   const [activeVariantId, setActiveVariantId] = useState(
//     item?.productType === "Variant" && item?.variants?.length
//       ? item?.variants[0]._id
//       : null,
//   );
//   const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

//   const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(
//     Boolean,
//   );

//   const primaryImage = useMemo(
//     () => galleryImages[0] || item?.thumbnail,
//     [galleryImages, item?.thumbnail],
//   );

//   const hoverImage = useMemo(
//     () => galleryImages[1] || galleryImages[0] || item?.thumbnail,
//     [galleryImages, item?.thumbnail],
//   );

//   const hasDiscount =
//     activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

//   const isOutOfStock = activeStock <= 0;

//   const handleAddToCart = (e) => {
//     const action = e.currentTarget.getAttribute("data-action");

//     try {
//       addToCart(item?._id, 1, activeVariantId || "");

//       if (action === "buy-now") {
//         navigate("/checkout");
//       }
//     } catch (err) {
//       console.error("Add to cart error:", err);
//     }
//   };

//   const handleWishlistToggle = async (e) => {
//     e.preventDefault();

//     const isLoggedIn = Auth.getToken();

//     if (!isLoggedIn) {
//       showError("Please log in to manage your wishlist");
//       return;
//     }

//     try {
//       const res = await wishlistAPI.addProduct({ productId: item?._id });
//       if (res.code === 200) {
//         setIsWishlisted((prev) => !prev);
//       }
//     } catch (error) {
//       showError("Failed to update wishlist");
//     }
//   };

//   return (
//     <div className="custom-product-card">
//       {hasDiscount && (
//         <div className="custom-product-badge">
//           {Math.round(activeDiscount)}% OFF
//         </div>
//       )}

//       <div
//         className={`custom-product-icons wishlist-btn ${isWishlisted ? "active" : ""}`}
//         onClick={handleWishlistToggle}
//         aria-label="Add to wishlist"
//       >
//         <Heart
//           size={20}
//           strokeWidth={1.5}
//           fill={isWishlisted ? "currentColor" : "none"}
//           className="custom-product-icon"
//         />
//       </div>

//       <div className="custom-product-image-wrapper">
//         <Link to={`/shop/${slug}`} className="custom-product-image-link">
//           <img
//             src={primaryImage}
//             alt={title}
//             loading="lazy"
//             className="custom-product-image custom-product-image-main"
//           />
//           <img
//             src={hoverImage}
//             alt={title}
//             loading="lazy"
//             className="custom-product-image custom-product-image-hover"
//           />
//         </Link>

//         {!isOutOfStock && config?.productVisibility === "cart" && (
//           <>
//           <button
//             className="custom-hover-cart-btn"
//             data-id={item?._id}
//             data-price={activePrice}
//             data-variant={activeVariantId || ""}
//             data-quantity={1}
//             data-action="cart"
//             data-bs-toggle="offcanvas"
//             data-bs-target="#shoppingCartCanvas"
//             onClick={handleAddToCart}
//           >
//             Add to Bag
//           </button>
//           </>
//         )}
//       </div>

//       {/* <div className="product-details text-center px-3 py-3">
//         <h4 className="custom-product-title ">{title}</h4>
//          <p className="custom-product-title-subtitle">{item.shortDescription}</p>
        

//         <div className="d-flex align-items-center justify-content-left gap-2">
//           <p className="custom-product-price mb-0">₹{activePrice}</p>
      
//            {Number(activeMrp) > Number(activePrice) && (
//     <p className="custom-product-price-del mb-0">
//       ₹{activeMrp}
//     </p>
//   )}
//         </div>

//         {isOutOfStock && (
//           <p className="text-danger fw-bold mt-2 mb-0">Out of Stock</p>
//         )}
//       </div> */}
//       <div className="s px-0 ">
//         <h5 className="custom-product-title">
//     {title}
//   </h5>
//   {/* <p className="custom-product-category">
//     {item?.shortDescription}
//   </p> */}

  

//   <div className="custom-product-price-wrap">
//     <p className="custom-product-price mb-0">
//       ₹{activePrice}
//     </p>

//     {Number(activeMrp) > Number(activePrice) && (
//       <p className="custom-product-price-del mb-0">
//         ₹{activeMrp}
//       </p>
//     )}
//   </div>

//   {isOutOfStock && (
//     <p className="text-danger fw-bold mt-2 mb-0">
//       Out of Stock
//     </p>
//   )}
// </div>
//     </div>
//   );
// }

// export default Card;









import React, { useMemo, useState } from "react";
import { Star, Plus, ArrowUpRight, Heart } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

const Card = ({ item }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? item?.productPrice ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [activePrice] = useState(initialPrice);
  const [activeMrp] = useState(initialMrp);
  const [activeDiscount] = useState(initialDiscount);
  const [activeStock] = useState(initialStock);
  const [activeVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null
  );
  const [isWishlisted, setIsWishlisted] = useState(item?.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(Boolean);
  const primaryImage = useMemo(
    () => galleryImages[0] || item?.thumbnail || item?.productImage,
    [galleryImages, item?.thumbnail, item?.productImage]
  );

  const hasDiscount = activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;
  const isOutOfStock = activeStock <= 0;

  const handleAddToCart = (e) => {
    e.stopPropagation();
    try {
      addToCart(item?._id || item?.id, 1, activeVariantId || "");
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isLoggedIn = Auth.getToken();
    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id || item?.id });
      if (res?.code === 200 || res?.success) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  const getTheme = (type) => {
    switch (type) {
      case "red": return "bg-[var(--color-primary)]/30";
      case "green": return "bg-[var(--color-accent-green)]/30";
      case "gold": return "bg-[var(--color-accent-gold)]/30";
      default: return "bg-[var(--color-tan)]/30";
    }
  };

  const glowColor = getTheme(item?.type || "gold");
  const displayTitle = item?.title || item?.productName;
  const displayVintage = item?.vintage || "2024";
  const displayRating = item?.productRating || item?.rating || "4.9";
  const displayRegion = item?.region || item?.shortDescription || "Organic Blend";

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      onClick={() => navigate(`/shop/${item?.slug || item?.productId || item?.id}`)}
      className="group relative w-full cursor-pointer flex flex-col h-full bg-transparent"
    >
      {/* --- 1. VISUAL FRAME (Top) --- */}
      <div 
        className="relative w-full aspect-[4/5] rounded-[var(--radius-lg)] overflow-hidden isolate transition-colors duration-500 border flex-shrink-0"
        style={{
          backgroundColor: "var(--color-bg)",
          borderColor: "var(--color-border)"
        }}
        onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--color-bg-alt)"}
        onMouseLeave={e => e.currentTarget.style.backgroundColor = "var(--color-bg)"}
      >
        {/* Ethereal Aura */}
        <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 sm:w-40 h-32 sm:h-40 rounded-full blur-[80px] ${glowColor} opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-out group-hover:scale-150`} />

        {/* Discount Badge */}
        {hasDiscount && (
          <div className="absolute top-3 sm:top-6 left-3 sm:left-6 z-30 bg-[var(--color-primary)] text-[var(--color-white)] text-[9px] sm:text-[10px] font-bold px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-full uppercase tracking-wider">
            {Math.round(activeDiscount)}% OFF
          </div>
        )}

        {/* Vertical Vintage Label */}
        {!hasDiscount && (
          <div className="absolute top-3 sm:top-6 left-3 sm:left-6 z-20">
            <span
              className="block [writing-mode:vertical-rl] rotate-180 uppercase tracking-[0.25em]"
              style={{
                fontFamily: "var(--font-heading)",
                fontSize: "var(--font-size-xs)",
                fontWeight: "var(--font-weight-bold)",
                color: "var(--color-text-muted)",
                transition: "color 0.4s ease",
              }}
            >
              Est. {displayVintage}
            </span>
          </div>
        )}

        {/* Wishlist Icon */}
        <div 
          onClick={handleWishlistToggle}
          className={`absolute top-3 sm:top-6 right-3 sm:right-6 z-30 w-7 sm:w-8 h-7 sm:h-8 rounded-full bg-[var(--color-white)]/80 backdrop-blur-md flex items-center justify-center transition-all duration-300 ${isWishlisted ? "text-[var(--color-primary)]" : "text-[var(--color-text-muted)] hover:text-[var(--color-primary)]"}`}
        >
          <Heart size={15} fill={isWishlisted ? "currentColor" : "none"} className="sm:w-4 sm:h-4" />
        </div>

        {/* Rating */}
        <div className="absolute top-12 sm:top-16 right-3 sm:right-6 z-20 flex flex-col items-center gap-0.5 sm:gap-1 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-all duration-500">
          <Star size={9} className="sm:w-[10px] sm:h-[10px] fill-[var(--color-accent-gold)] text-[var(--color-accent-gold)]" />
          <span style={{ fontFamily: "var(--font-heading)", fontSize: "var(--font-size-xs)", fontWeight: "var(--font-weight-bold)", color: "var(--color-text)" }}>
            {displayRating}
          </span>
        </div>

        {/* Product Image */}
        <div className="absolute inset-0 flex items-center justify-center z-10 p-2">
          <img
            src={primaryImage}
            alt={displayTitle}
            className="w-full h-full object-contain transition-all duration-700 ease-[cubic-bezier(0.33,1,0.68,1)] group-hover:scale-105"
          />
        </div>

        {/* Add Button */}
        {!isOutOfStock && (
          <div className="absolute bottom-3 sm:bottom-6 right-3 sm:right-6 z-30">
            <button
             data-action="cart"
            data-bs-toggle="offcanvas"
            data-bs-target="#shoppingCartCanvas"
              onClick={handleAddToCart}
              className="w-8 sm:w-10 h-8 sm:h-10 rounded-full flex items-center justify-center shadow-sm transition-all duration-300 group-hover:scale-110 hover:!scale-125"
              style={{
                background: "var(--color-white)",
                border: "1px solid var(--color-border)",
                color: "var(--color-text)",
              }}
            >
              <Plus size={16} className="sm:w-[18px] sm:h-[18px]" />
            </button>
          </div>
        )}
      </div>

      {/* --- 2. MINIMAL DETAILS (Bottom) --- */}
      <div className="pt-2.5 sm:pt-4 px-1 flex flex-col gap-1 mt-auto">
        <div className="flex items-start justify-between gap-2">
          <h3
            className="font-medium leading-tight line-clamp-1 text-xs sm:text-base flex-1"
            style={{
              fontFamily: "var(--font-heading)",
              color: "var(--color-text)",
              letterSpacing: "-0.01em",
            }}
          >
            {displayTitle}
          </h3>
          <div className="flex items-center gap-1.5 shrink-0">
            <span style={{ fontFamily: "var(--font-heading)", fontWeight: "var(--font-weight-bold)", color: "var(--color-text)" }} className="text-xs sm:text-sm">
              ₹{activePrice}
            </span>
            {Number(activeMrp) > Number(activePrice) && (
              <span className="line-through text-[10px] sm:text-xs text-[var(--color-text-muted)]">
                ₹{activeMrp}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between gap-2">
          <p 
            style={{ fontFamily: "var(--font-body)", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--color-text-muted)" }}
            className="transition-colors duration-300 truncate text-[9px] sm:text-xs"
          >
            {displayRegion}
          </p>

          <div className="flex items-center gap-0.5 sm:gap-1 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-all duration-500 shrink-0">
            <span style={{ fontFamily: "var(--font-body)", fontWeight: "var(--font-weight-bold)", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--color-primary)" }} className="text-[9px] sm:text-xs">
              View
            </span>
            <ArrowUpRight size={10} style={{ color: "var(--color-primary)" }} />
          </div>
        </div>

        {isOutOfStock && (
          <p className="text-[var(--color-primary)] text-[10px] sm:text-xs font-bold mt-0.5">Out of Stock</p>
        )}
      </div>
    </motion.div>
  );
};

export default Card;